import css from 'styled-jsx/css';

export default css`
  @import '../../styles/colors.scss';
  .bubble {
    position: relative;
    max-width: 100%;
    background: $color-gp--white;
    box-shadow: 0px 2px 4px #00000029;
    border: 1px solid #dddddd;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
    align-content: stretch;
    padding: 16px;
    .bubble__icon {
      padding-right: 24px;
    }
    :global(.bubble__text) {
      display: flex;
      flex-direction: column;
    }
  }
  .bubble:before {
    border: 8px solid $color-gp--white;
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    border: 1px solid #dddddd;
    border-top: none;
    border-right: none;
    -webkit-transform: rotate(315deg);
    -ms-transform: rotate(315deg);
    transform: rotate(315deg);
    bottom: -8px;
    left: 40%;
    background-color: $color-gp--white;
  }
`;
